export default "__VITE_ASSET__BO$Okh7N__"